import React from 'react';
import classNames from 'classnames';
import { Container } from '../container';
import { AButton } from '../abutton';

export const G2Section = () => {
  return (
    <section className="px-4 py-10 sm:p-20">
      <div
        className={classNames(
          'relative z-[1] overflow-hidden rounded-2xl bg-azure-800 px-2 py-6 sm:p-20',
          "before:absolute before:-left-[660px] before:bottom-0 before:top-1/2 before:-z-[1] before:h-[961px] before:w-full before:-translate-y-1/2 before:bg-[url('https://cdn.runalloy.com/landing/2025/g2-pixel.webp')] before:bg-center before:bg-no-repeat",
          "after:absolute after:-right-[668px] after:bottom-0 after:top-1/2 after:-z-[1] after:h-[961px] after:w-full after:-translate-y-1/2 after:bg-[url('https://cdn.runalloy.com/landing/2025/g2-pixel.webp')] after:bg-center after:bg-no-repeat"
        )}
      >
        <Container className="flex flex-col items-center justify-center">
          <p className="mb-5 text-white text-label">The Industry Leader</p>
          <h3 className="mb-0 text-center !font-semibold text-white text-h4 sm:text-h3">
            Alloy Automation is proud to be <br />
            ranked as an industry <br />
            leader by G2.
          </h3>
          <div className="my-8 flex flex-row gap-4 sm:my-11 [&_img]:object-contain">
            <img
              src="https://cdn.runalloy.com/landing/g2/badge/easiest-to-do-business-with-fall-24.svg"
              alt="easiest-to-do-business-with-fall-24"
              height={96}
              width={74}
              className="opacity-80"
            />
            <img
              src="https://cdn.runalloy.com/landing/g2/badge/best-support-fall-24.svg"
              alt="best-support-fall-24"
              height={96}
              width={74}
              className="opacity-80"
            />
            <img
              src="https://cdn.runalloy.com/landing/g2/badge/best-meets-requirements-fall-24.svg"
              alt="best-meets-requirements-fall-24"
              height={96}
              width={74}
            />
            <img
              src="https://cdn.runalloy.com/landing/g2/badge/leader-fall-24.svg"
              alt="leader-fall-24"
              height={96}
              width={74}
            />
            <img
              src="https://cdn.runalloy.com/landing/g2/badge/momentum-leader-fall-24.svg"
              alt="momentum-leader-fall-24"
              height={96}
              width={74}
            />
            <img
              src="https://cdn.runalloy.com/landing/g2/badge/high-performer-fall-24.svg"
              alt="high-performer-fall-24"
              height={96}
              width={74}
              className="opacity-80"
            />
            <img
              src="https://cdn.runalloy.com/landing/g2/badge/americas-high-performer-fall-24.svg"
              alt="americas-high-performer-fall-24"
              height={96}
              width={74}
              className="opacity-80"
            />
          </div>
          <h2 className="mb-6 text-center text-white text-h3 sm:text-h2">
            “The Easiest to do <br />
            Business With”
          </h2>
          <AButton
            type="tertiary"
            href="https://www.g2.com/products/alloy-alloy-automation/reviews"
            target="_blank"
            rel="noreferrer"
          >
            Read the report
          </AButton>
        </Container>
      </div>
    </section>
  );
};
